import { FC } from 'react';
import { PlanType } from '../../../types/plan';
import { MainButton, MainButtonVariant } from '../../styledComponent/Buttons.style';
import { LogoWithName } from '../LogoWithName';
import { RootBox, Wrapper } from '../v2/BaseStepV2';
import { ColWithBackgroundImage } from '../v2/TwoSidedLayout/ColWithBackgroundImage';
import { TwoSidedLayout } from '../v2/TwoSidedLayout/TwoSidedLayout.style';
import {
  PaymentFailureButtonWrapper,
  PaymentFailureContent,
  PaymentFailureContentBoxWrapper,
  PaymentFailureDescription,
  PaymentFailureLabel,
  PaymentFailureLeftCol,
  PaymentFailureLogoWrapper,
  PaymentFailureTitle,
} from './PaymentFailure.styled';

const oneTimePaymentExpressCheckout = 'voices-program-express-v2';
const recurringPaymentExpressCheckout = 'voices-express-v2';

interface PaymentFailureProps {
  planType: PlanType | null;
}

export const PaymentFailure: FC<PaymentFailureProps> = (props) => {
  const { planType } = props;
  const urls = {
    backgroundImageUrl:
      'https://res.cloudinary.com/better-with-us/image/upload/f_auto,q_auto/onboarding-v4/web_go_to_app_v2_step.webp',
  };

  const onTryAgainClick = () => {
    const redirectionUrlBase = `${process.env.REACT_APP_WEBSITE}/onboarding/document/${
      planType === PlanType.OneTime ? oneTimePaymentExpressCheckout : recurringPaymentExpressCheckout
    }`;

    window.location.replace(redirectionUrlBase);
  };

  return (
    <RootBox addSpacingNeededForMobileButton={false}>
      <Wrapper>
        <TwoSidedLayout>
          <PaymentFailureLeftCol>
            <PaymentFailureContentBoxWrapper>
              <PaymentFailureContent>
                <PaymentFailureLogoWrapper>
                  <LogoWithName />
                </PaymentFailureLogoWrapper>
                <PaymentFailureTitle>Payment process failed</PaymentFailureTitle>
                <PaymentFailureDescription>
                  Don’t worry, let’s get you back on track—click below to retry and start your healing journey!
                </PaymentFailureDescription>
                <PaymentFailureLabel>
                  If the issue persists, please contact our support team at{' '}
                  <a href="mailto:Support@circlesup.com">Support@circlesup.com</a> We’re here to help!
                </PaymentFailureLabel>
                <PaymentFailureButtonWrapper>
                  <MainButton variant={MainButtonVariant.Black} onClick={onTryAgainClick}>
                    Try Again
                  </MainButton>
                </PaymentFailureButtonWrapper>
              </PaymentFailureContent>
            </PaymentFailureContentBoxWrapper>
          </PaymentFailureLeftCol>
          <ColWithBackgroundImage img={urls.backgroundImageUrl}></ColWithBackgroundImage>
        </TwoSidedLayout>
      </Wrapper>
    </RootBox>
  );
};
